export enum EPreviewTextVariantKey {
    sidebar_athletes = "sidebar_athletes",
    most_active_athletes = "most_active_athletes",
    sidebar_athletes_link = "sidebar_athletes_link",
    athletes_title = "athletes_title",
    create_athlete_button_label = "create_athlete_button_label",
    reached_athletes_limit = "reached_athletes_limit",
    save_athlete_link = "save_athlete_link",
    remove_selected_athletes = "remove_selected_athletes",
    no_athletes = "no_athletes",
    no_athletes_description = "no_athletes_description",
    athletes_page_link = "athletes_page_link",
    sidebar_workouts = "sidebar_workouts",
    sidebar_workouts_link = "sidebar_workouts_link",
    create_workout_link = "create_workout_link",
    workouts_title = "workouts_title",
    deleted_workouts = "deleted_workouts",
    push_workouts_to_locaitons = "push_workouts_to_locaitons",
    this_workout_is_empty = "this_workout_is_empty",
    restore_deleted_workouts = "restore_deleted_workouts",
    go_to_workouts = "go_to_workouts",
    no_deleted_workouts = "no_deleted_workouts",
    create_workout_title = "create_workout_title",
    add_new_playlist_to_workout = "add_new_playlist_to_workout",
    edit_workout_title = "edit_workout_title",
    push_workouts_success = "push_workouts_success",
    push_workouts_error = "push_workouts_error",
    workout_created_success = "workout_created_success",
    workout_edited_success = "workout_edited_success",
    get_workout_error = "get_workout_error",
    delete_workout_confirm_text = "delete_workout_confirm_text",
    athlete_updated_success = "athlete_updated_success",
    athlete_created_success = "athlete_created_success",
    atheletes_bulk_import_error = "atheletes_bulk_import_error",
    most_active_exercise_athelete_name = "most_active_exercise_athelete_name",
    athlete_bulk_import_template = "athlete_bulk_import_template",
    remaining_athletes = "remaining_athletes",
    restore_workout_confirm_text = "restore_workout_confirm_text",
    workout_title = "workout_title"
}

export type IPreviewTextVariant = {
    [k in EPreviewTextVariantKey]: string;
};
